<template>
  <div class="chart-box2" ref="chartBox">
    <div :id="chartId" class="chart" :style="{ width, height }"></div>
    <div class="total" :style="{ top: totalTop, left: totalLeft }">
<!--      <el-tooltip effect="dark" placement="top-start" :content="total">-->
        <span class="num">{{ total }}</span>
      <div>{{text}}</div>
<!--      </el-tooltip>-->
    </div>
  </div>
</template>
<script>
import * as echarts from 'echarts'
export default {
  name: 'RingChart',
  props: {
    chartId: { type: String, default: 'ringChart' },
    title: { type: String, default: '' },
    titleFontSize: { type: Number, default: 14 },
    titleTextAlign: { type: String, default: 'auto' },
    titleTop: { type: String, default: 'middle' },
    titleRight: { type: String, default: 'center' },
    name: { type: String, default: '' },
    total: { type: String, default: '' },
    text: {type: String, default: ''},
    totalTop: { type: String, default: '50%' },
    totalLeft: { type: String, default: '0%' },
    data: { type: Array, default: () => [] },
    width: { type: String, default: '100%' },
    height: { type: String, default: '100%' },
    gridTop: { type: Number, default: 25 },
    center: { type: Array, default: () => ['50%', '50%'] },
    radius: { type: Array, default: () => ['35%', '55%'] },
    legendShow: { type: Boolean, default: true },
    legendOrient: { type: String, default: 'horizontal' },
    legendTop: { type: String, default: 'middle' },
    legendRight: { type: String, default: '0%' },
    legendFontSize: { type: Number, default: 12 },
    legendWidth: { type: [Number, String], default: 'auto' },
    color: {
      type: Array,
      default: () => ['#3173F1', '#FD991F', '#33C389', '#F8CC2C', '#45BFF7', '#71C33A', '#4C50EE', '#7950E5', '#E54C91', '#EB4F4E']
    }
  },
  data() {
    return {
      chartIns: null,
      optionEcharts: {}
    }
  },
  watch: {
    data: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (this.chartIns) {
          this.renderChart()
        }
      }
    }
  },
  mounted() {
    this.initOption()
    this.$nextTick(() => {
      this.createChart()
      window.addEventListener('resize', this.resizeChart)
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeChart)
    if (this.chartIns) this.chartIns.dispose()
  },
  methods: {
    initOption() {
      this.optionEcharts = {
        title: {
          text: this.title,
          top: this.titleTop,
          right: this.titleRight,
          textAlign: this.titleTextAlign,
          textStyle: { fontSize: this.titleFontSize }
        },
        tooltip: {
          trigger: 'item',
          confine: true
        },
        color: this.color,
        legend: {
          show: false,
          itemWidth: 6,
          itemHeight: 6,
          top: this.legendTop,
          right: this.legendRight,
          orient: this.legendOrient,
          textStyle: { fontSize: this.legendFontSize, width: this.legendWidth, overflow: "truncate" },
          type: 'scroll'
        },
        grid: { top: this.gridTop },
        series: [
          {
            name: this.name,
            type: 'pie',
            center: this.center,
            radius: this.radius,
            labelLine: { length: 30 },
            label: {
              show: false,
              position: 'inner',
              formatter: '{c}',
              rich: {
                a: { color: '#6E7079', lineHeight: 22, align: 'center' },
                hr: { borderColor: '#8C8D8E', width: '100%', borderWidth: 1, height: 0 },
                b: { color: '#4C5058', fontSize: 14, fontWeight: 'bold', lineHeight: 33 },
                per: { color: '#fff', backgroundColor: '#4C5058', padding: [3, 4], borderRadius: 4 }
              }
            },
            data: this.data
          }
        ]
      }
    },
    createChart() {
      const dom = document.getElementById(this.chartId)
      this.chartIns = echarts.init(dom)
      this.renderChart()
      this.chartIns.on('click', (param) => {
        if (param.seriesIndex === 0) this.$emit('handleChart', param)
      })
    },
    renderChart() {
      if (!this.chartIns) return
      this.optionEcharts.series[0].data = this.data
      this.chartIns.setOption(this.optionEcharts)

    },
    resizeChart() {
      if (this.chartIns) this.chartIns.resize()
    }
  }
}
</script>
<style lang="scss" scoped>
.chart-box2 {
  position: relative;
  width: 100%;
}
.chart {
  width: 100%;
}
.total {
  position: absolute;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  .num {
    overflow: hidden;
    white-space: nowrap;
    color: #4d9aff;
    font-size: 18px;
    font-weight: bold;
  }
  div {
    font-size: 12px;
    color: #94a7c8;
    margin-top: 0px;
  }
}
</style>
